import { useState, useRef, RefObject } from "react";
import { Outlet } from "react-router-dom";
import styles from "./Layout.module.css";
import { Sidebar } from "../../components/Sidebar";
import { LivingBackground } from "../../components/ui";
import { WorkflowReminders } from "../../features/workflowReminders/WorkflowReminders";

const Layout = () => {
    const sidebarRef: RefObject<HTMLDivElement> = useRef(null);

    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <div className={`${styles.layout} ${sidebarOpen ? styles.sidebarOpen : styles.sidebarCollapsed} bg-glass-bg`}>
            {/* Ethereal Glass Living Background - App Wide */}
            <LivingBackground />

            <Sidebar sidebarRef={sidebarRef} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

            <main className={styles.mainContent}>
                <div id="drag-drop-root"></div>
                <Outlet />
            </main>
            <div id="dropdown-root"></div>
            <WorkflowReminders />
        </div>
    );
};

export default Layout;
